exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.modal i{margin-top:.5rem}.modal .fa-exclamation-circle{color:#ffa856}.modal .title{color:#555}.modal p{font-size:1rem}.modal button{color:#fff;margin:1rem;padding:.5rem 1rem;border:none;border-radius:5px;border-bottom:4px solid #2c7b97;font-family:Lato,arial,sans-serif;font-size:1.2rem;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/modals/styles.scss
// module id = 1031
// module chunks = 0